export default "dist/images/components-columns-width-control-4-1-grid.2ae6bc7.png";